import React from 'react';
import { useRouter } from 'next/router';
import { PrimaryCta } from '#components/cta/PrimaryCta';
export const NetworkError = () => {
  const router = useRouter();
  return <section className="absolute top-1/2 w-full -translate-y-1/2 p-4">
      <div className="flex flex-col items-center">
        <h2 className="text-center text-6xl uppercase">Connection Lost</h2>
        <p className="mb-8 mt-2 font-chakra-petch text-sm">
          Please check your connection and try again.
        </p>
        {/* eslint-disable-next-line no-restricted-globals */}
        <PrimaryCta onClick={() => router.reload()} className="h-10 w-48 p-0 uppercase leading-10">
          Reload
        </PrimaryCta>
      </div>
    </section>;
};